import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';

const faqs = [
  {
    q: 'Saan exactly ang Asana?',
    a: 'We are located in Bulacan, approximately 90 minutes from Quezon City via NLEX. Detailed pin and directions are sent upon booking confirmation.',
  },
  {
    q: 'Anong oras kayo bukas?',
    a: 'Open Tuesday to Sunday, 6:00 AM – 6:00 PM. Closed every Monday for pond maintenance and feeding cycles. Holidays follow weekend hours.',
  },
  {
    q: 'Need ko ba magdala ng sariling gear?',
    a: 'Hindi po required. All rods, bait, and basic gear are included in the booking. Pwede rin magdala ng sariling rod kung mas comfortable.',
  },
  {
    q: 'Pwede ba akong magdala ng pagkain at inumin?',
    a: 'Yes, allowed ang outside food para sa picnic-style visits. May BBQ grill rental kami if you want to grill on-site. Alcohol is permitted in moderation; we ask that guests respect the calm environment.',
  },
  {
    q: 'May payment option ba sa booking?',
    a: 'Phase 1 booking is a reservation request. We will confirm your slot and provide payment instructions (GCash, bank transfer, or cash on arrival) within 24 hours of your request.',
  },
  {
    q: 'Kid-friendly ba talaga?',
    a: 'Absolutely. We have a designated shallow pond for kids and beginner lessons na perfect para sa first-timer kids. Always with a guide for safety.',
  },
  {
    q: 'What if umulan?',
    a: 'Booking is reschedulable up to 48 hours in advance with no fee. For sudden weather changes, our team will coordinate with you for a free reschedule.',
  },
  {
    q: 'May pet-friendly area ba?',
    a: 'Leashed dogs are welcome in designated cabana areas. We ask that pets stay away from the pond edges for both their safety and pond stewardship.',
  },
];

function Item({ q, a, i, open, setOpen }) {
  const isOpen = open === i;
  return (
    <div className="border-b border-moss/30">
      <button
        onClick={() => setOpen(isOpen ? null : i)}
        data-testid={`faq-toggle-${i}`}
        className="w-full flex items-start justify-between gap-6 py-6 md:py-8 text-left"
        aria-expanded={isOpen}
      >
        <span className="editorial-display text-pond text-xl md:text-2xl leading-snug flex-1">
          {q}
        </span>
        <span className="mt-1 text-pond flex-shrink-0">
          {isOpen ? <Minus className="w-5 h-5" /> : <Plus className="w-5 h-5" />}
        </span>
      </button>
      <div
        className={`overflow-hidden transition-all duration-500 ease-in-out ${
          isOpen ? 'max-h-96 opacity-100 pb-6 md:pb-8' : 'max-h-0 opacity-0'
        }`}
      >
        <p className="text-charcoal/80 text-base md:text-lg leading-relaxed pr-8 md:pr-16">{a}</p>
      </div>
    </div>
  );
}

export default function FAQ() {
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" data-testid="faq-section" className="py-20 md:py-32 bg-sand">
      <div className="max-w-5xl mx-auto px-6 md:px-10 lg:px-16">
        <div className="mb-12 md:mb-16 max-w-2xl">
          <p className="overline text-muted mb-4">Plan your visit</p>
          <h2 className="editorial-display text-pond text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
            Mga itinatanong
            <br />
            <em className="italic font-light text-moss">bago bumiyahe.</em>
          </h2>
        </div>

        <div>
          {faqs.map((f, i) => (
            <Item key={i} {...f} i={i} open={open} setOpen={setOpen} />
          ))}
        </div>
      </div>
    </section>
  );
}
